import { Button } from 'react-bootstrap';

interface SocialPostActionsProps {
	isLiked: boolean;
	isLike: boolean;
	likes: number;
	totalLikes: number;
	totalComments: number;
	onLike: () => void;
	onShowLikes: () => void;
	onComment: () => void;
	onShare: () => void;
	isPending: boolean;
	type: string;
	token: string;
	withAuth: (token: string | undefined, callback: () => void) => () => void;
	unitNumber: (number: number, decimals: number) => string;
	translate: (key: string) => string;
	postId: number | string;
	setModalConfig: (config: {
		visible: boolean;
		id: number | string;
		type: string;
		onClick?: () => void;
		onClose?: () => void;
		contentType?: string;
		props?: {
			size?: string;
		};
	}) => void;
}
const SocialPostActions: React.FC<SocialPostActionsProps> = ({
	isLiked,
	isLike,
	likes,
	totalLikes,
	totalComments,
	onLike,
	onShowLikes,
	onComment,
	onShare,
	isPending,
	type,
	token,
	withAuth,
	unitNumber,
	translate,
}) => (
	<div className="social-post-actions d-flex gap-1 gap-sm-3">
		<div className="d-flex gap-1 gap-sm-2">
			<Button
				className="gray-transparent-btn post-like-btn rounded-pill"
				disabled={isPending}
				onClick={withAuth(token, onLike)}
			>
				{['hash', 'myfeeds'].includes(type) ? (
					<i className={`ri-heart-3-${isLiked ? 'fill' : 'line'} me-0`}></i>
				) : (
					<i className={`ri-heart-3-${isLike ? 'fill' : 'line'} me-0`}></i>
				)}
			</Button>
			<Button
				disabled={isPending}
				className="gray-transparent-btn rounded-pill"
				onClick={withAuth(token, onShowLikes)}
			>
				{!['hash', 'myfeeds'].includes(type) ? unitNumber(totalLikes, 0) : likes}{' '}
				{translate('Social.likes')}
			</Button>
		</div>
		<Button className="gray-transparent-btn rounded-pill" onClick={withAuth(token, onComment)}>
			<i className="ri-chat-3-line"></i> {unitNumber(totalComments, 0)}{' '}
			{translate('Social.comments')}
		</Button>
		<Button onClick={withAuth(token, onShare)} className="gray-transparent-btn rounded-pill">
			<i className="ri-share-forward-line"></i> {translate('Social.share')}
		</Button>
	</div>
);

export default SocialPostActions;
